import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';

import { ConsumerPointsHandlerProvider } from '../../providers/consumer-points-handler';
import { ConsumerPunchCardHandler } from '../../providers/consumer-punch-card-handler';

@Component({
  selector: 'page-consumer-punch-card-qr',
  templateUrl: 'consumer-punch-card-qr.html',
})
export class ConsumerPunchCardQrPage {
	qrCodeUrl: any;
  punchCardId: any;
  getPunchResultInterval: any;
  punchAnswerRecieved: boolean = false;

  constructor(
  	public navCtrl: NavController, 
  	public navParams: NavParams,
    public alertCtrl: AlertController,
    public consumerPointsHandlerProvider: ConsumerPointsHandlerProvider,
    public punchCardManagerHandler: ConsumerPunchCardHandler,) {

  	this.qrCodeUrl = navParams.get('qrCodeUrl');
    this.punchCardId = navParams.get('punchCardId');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ConsumerPunchCardQrPage');
  }

  ionViewDidLeave(){
    clearInterval(this.getPunchResultInterval);
  }
  
  setIntervalSearch(){
    this.getPunchResultInterval = setInterval(()=>{

      this.punchCardManagerHandler.getPunchCardSequencesByPunchCardId(this.punchCardId, (punchedCard)=>{
        if(this.punchAnswerRecieved) return

        if(punchedCard){
          this.punchAnswerRecieved = true;
          clearInterval(this.getPunchResultInterval);

          let alert = this.alertCtrl.create({
            title: 'Punch',
            subTitle: 'Your card has been punched and you have earned ' + punchedCard.EarnedPoints + ' points!',
            buttons: ['Ok']
          });

          //this.caller.load()

          this.consumerPointsHandlerProvider.getPointsByUser(null)

          alert.present();          

          this.navCtrl.pop();
        }
      })
    }, 1000)
  }

}



// WEBPACK FOOTER //
// ./src/pages/consumer-punch-card-qr/consumer-punch-card-qr.ts